import React from 'react';
import { Button, Tooltip } from '@mui/material';
import ExploreIcon from '@mui/icons-material/Explore';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const SearchButton = () => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    // Kullanıcıyı search-results sayfasına yönlendir
    navigate('/search-results');
  };

  return (
    <Tooltip title={translate('homepage.discover_tooltip')} arrow>
      <Button
        variant="contained"
        startIcon={<ExploreIcon />}
        onClick={handleClick}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.7) !important',
          backdropFilter: 'blur(10px)',
          color: 'rgba(128, 128, 128, 0.9) !important;',
          textTransform: 'none',
          fontSize: '0.850rem !important',
          fontWeight: 'bold !important',
          padding: '8px 24px',
          borderRadius: '15px',
          width: {
            xs: '100%',
            sm: '90%',
            md: '70%',
            lg: 'auto',
          },
          maxWidth: '750px',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
            boxShadow: '0 7px 14px rgba(0, 0, 0, 0.12), 0 3px 6px rgba(0, 0, 0, 0.08)',
            transform: 'translateY(-1px)',
          },
          '&:active': {
            boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
            transform: 'translateY(0)',
          },
        }}
      >
        {translate('homepage.discover_button')}
      </Button>
    </Tooltip>
  );
};

export default SearchButton;
